module.exports = __webpack_public_path__ + "img/deleteIcon.9e67608d.svg";